<table data-testid="stemmeberettigede">
  <tr>
    <th>{{ "Navn"|translate }}</th>
    @if(visAntallAksjer()){
      <th colspan="3" class="aksjer">{{ "Antall aksjer"|translate }}</th>
    }
    <th class="stemmevekt">{{ "Stemmevekt"|translate }}</th>
    <th class="kommentar">{{ "Kommentar"|translate }}</th>
    <th class="status">{{ "Stemme avgitt"|translate }}</th>
    <th></th>
  </tr>
  <tbody>
  @for (modell of modeller(); track modell.deltaker.id;) {
    <tr data-testid="stemmeberettiget" (click)="gaaTilMedlem(modell)">
      <td data-testid="navn">{{modell.deltaker.medlem.navn}}</td>
      @if(visAntallAksjer()){
        <td class="antall">{{modell.antallAksjerTotalt}}</td>
        <td class="andel">({{modell.eierandel|prosent}})</td>
        <td class="varsler">
          @if(modell.advarslerTooltipTekst != null){
            <i class="icon ion-android-warning" [matTooltip]="modell.advarslerTooltipTekst"></i>
          }
        </td>
      }
      <td class="stemmevekt" data-testid="stemmevekt">{{modell.deltaker.stemmevekt}}</td>
      <td data-testid="stemmekommentar">{{modell.deltaker.stemmekommentar}}</td>
      <td class="status">
        <c3-todelt-pai [andel]="avstemningsstatus().antallStemmerAvgittPerDeltaker[modell.deltaker.id]"
                       [totalt]="avstemningsstatus().antallAvstemninger"
                       [konfig]="pieKonfig"
                       [matTooltip]="modell.pieTooltipTekst"/>
      </td>
      <td class="meny">
        <button mat-icon-button [matMenuTriggerFor]="meny" (click)="$event.stopPropagation()" aria-label="Stemmeberettigetmeny" class="mat-small-icon-button">
          <mat-icon class="material-symbols-fet">more_vert</mat-icon>
        </button>
        <mat-menu #meny="matMenu">
          <button mat-menu-item (click)="nullstillAvgitteStemmer(modell)">
            <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
            <span>{{ "Nullstill stemmer" | translate }}</span>
          </button>
        </mat-menu>
      </td>
    </tr>
  }
  </tbody>
</table>
